import { render, staticRenderFns } from "./PlayerActionButton.vue?vue&type=template&id=12f1fb8e"
import script from "./PlayerActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerActionButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports